function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#000",
  d: "M2 2h19v19H2z"
}), React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: .2,
  d: "M6.46 10.748c1.29 0 2.339-1.009 2.339-2.249 0-1.24-1.05-2.249-2.339-2.249-1.29 0-2.339 1.009-2.339 2.249 0 1.24 1.05 2.249 2.339 2.249zm0-3.69c.827 0 1.499.647 1.499 1.441S7.287 9.94 6.46 9.94c-.827 0-1.499-.646-1.499-1.44 0-.795.672-1.442 1.499-1.442z"
}), React.createElement("path", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: .2,
  d: "M1 1v21h21V1H1zm.84.808h19.32V12.6L16.824 8.78a.428.428 0 0 0-.594.025l-4.113 4.333-1.992-1.916a.433.433 0 0 0-.575-.017l-7.029 5.95H1.84V1.808zm19.32 19.384H1.84v-3.23h19.32v3.23zM3.793 17.154l6.016-5.093 4.327 4.16c.164.158.43.158.593 0a.393.393 0 0 0 0-.571l-2.019-1.941 3.856-4.06 4.594 4.048v3.457H3.793z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-all-posts.bea0da21.svg";
export { SvgComponent as ReactComponent };